var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFieldHockey(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50px",
    height: "50px",
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ICON_Field_Hockey") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ICON_Field_Hockey",
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "np_ice-hockey_3075990_000000",
    transform: "translate(8.000000, 6.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.00165814166,15.1129412 C0.00165814166,12.4929365 2.13100221,10.3635791 4.7509904,10.3635791 C7.37097859,10.3635791 9.50032266,12.4945532 9.50032266,15.1129412 C9.50032266,17.7329459 7.37097859,19.8623033 4.7509904,19.8623033 C2.13100221,19.8623033 0.00165814166,17.7329459 0.00165814166,15.1129412 Z M17.6127808,25.9087549 L4.31862996,25.9087549 C1.9382847,25.9087549 0,27.8454351 0,30.2274121 L0,33.6813429 C0,36.0617031 1.93666801,38 4.31862996,38 L16.2655407,38 C21.3680571,38 22.2957873,36.4924496 23.385601,34.0311301 C23.3936972,34.0116986 23.4034131,33.9906475 23.4098902,33.9712169 L31.4788221,15.7638778 L24.6116284,10.3943668 L17.6127808,25.9087549 Z M25.3417936,8.77175307 L32.199453,14.135046 L33.3458921,11.5474168 L26.5027415,6.19573089 L25.3417936,8.77175307 Z M37.8603486,0.391866939 C37.7016603,0.147355831 37.4279882,0 37.1365283,0 L29.8564573,0 C29.5164098,0 29.2087458,0.199173084 29.0695033,0.508472339 L27.2348525,4.57450999 L34.0680543,9.91831965 L37.925182,1.21302116 C38.0450076,0.945838971 38.0190991,0.636564588 37.8604108,0.392028608 L37.8603486,0.391866939 Z",
    id: "Shape"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFieldHockey);
export default ForwardRef;